import React from 'react';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import {NotificationManager} from "react-notifications";
import * as PropTypes from "prop-types";
import {withStyles} from "@material-ui/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { t } from '../../i18n';
import {Spinner} from "../common/Spinner";
import {addRiskRevision} from "../../util/PlanningApiUtils";
import TextField from "@material-ui/core/TextField";

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

class RiskRevisionModal extends React.Component {

    constructor(props) {
        super(props);
        const today = new Date(),
            date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
        this.state = {
            isLoading: true,
            title: '',
            author: '',
            approvedBy: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
    }

    componentDidMount() {
        console.log('the revision is: ' + this.props.latestRevisionDto);
        console.log('the number is: ' + this.props.latestRevisionDto.number);
        this.setState({
            number: this.props.latestRevisionDto.number,
            isLoading: false,
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const request = {
            number: this.state.number,
            date: moment(this.state.date).format('YYYY-MM-DD'),
            title: this.state.title,
            author: this.state.author,
            approvedBy: this.state.approvedBy,
        };
        console.log(request);
        this.props.addRevision(request);
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            date: moment(date, "DD/MM/YYYY"),
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }
        return <div className={classes.paper}>
                    <Typography component="h2" variant="h5">{ t('context.revision.title') }</Typography>
                    <form onSubmit={this.handleSubmit} className={classes.form}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                variant="inline"
                                format="DD/MM/YYYY"
                                margin="normal"
                                id="date"
                                label={ t('context.revision.labels.date') }
                                name="date"
                                value={state.date}
                                onChange={ this.onDateChange }
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </MuiPickersUtilsProvider>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="author"
                            value={state.author}
                            label={ t('context.revision.labels.author') }
                            name="author"
                            onChange={ this.handleChange }
                            autoComplete="off"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="approvedBy"
                            value={state.approvedBy}
                            label={ t('context.revision.labels.approvedBy') }
                            name="approvedBy"
                            onChange={ this.handleChange }
                            autoComplete="off"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            { t('context.revision.submit') }
                        </Button>
                    </form>
                </div>;
    }
}

RiskRevisionModal.propType = {
    latestRevisionDto: PropTypes.object.isRequired,
    addRevision: PropTypes.func.isRequired
};

export default withStyles(classes)(RiskRevisionModal);